// modal.service.ts
import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

// Ce service gère les différents états du header.
@Injectable({
  providedIn: 'root',
})
export class HeaderService {
  private headerState = new Subject<void>();

  refresh() {
    this.headerState.next();
  }

  getHeaderState(): Observable<void> {
    return this.headerState.asObservable();
  }
}
